import imgOutside from '../../assets/buildings/skyscraper/outside.png';
import imgWaterFull from '../../assets/buildings/skyscraper/water-full.png';
import imgWaterUpper from '../../assets/buildings/skyscraper/water-upper.png';
import imgWaterLower from '../../assets/buildings/skyscraper/water-lower.png';
import imgFireProtection from '../../assets/buildings/skyscraper/fire-protection.png';
import imgWasteWater from '../../assets/buildings/skyscraper/waste-water.png';
import { BuildingArea } from '../../interfaces/buildings';
import { ProductType } from '../products';
import { TechSector } from '../tech-sector';
import { BuildingType } from '../buildings';
import { SubBuilding } from '../../interfaces/buildings';

const skyscraperConfig: BuildingArea = {
    techSectors: [
        {
            type: TechSector.WASTE_WATER,
            img: imgWasteWater,
            products: [
                {
                        position: {x: 196, y: 928},
                    type: ProductType.AMAREX
                },
                {
                        position: {x: 1145, y: 732},
                    type: ProductType.AMA_DRAINER_BOX_UNTERFLUR
                },
                {
                        position: {x: 1410, y: 720},
                    type: ProductType.AMA_DRAINER_4_5
                },
                {
                        position: {x: 1511, y: 597},
                    type: ProductType.LEVELCONTROL_BASIC_2
                },
                {
                        position: {x: 1640, y: 603},
                    type: ProductType.COMPACTA
                },
            ]
        },
        {
            type: TechSector.FIRE_PROTECTION,
            img: imgFireProtection,
            products: [
                {
                        position: { x: 1114, y: 793 },
                    type: ProductType.ETANORM_FXV,
                },
                {
                        position: { x: 1214, y: 753 },
                    type: ProductType.HYADUO_2_D_FL_COMPACT,
                },
                {
                        position: { x: 1417, y: 839 },
                    type: ProductType.AMA_DRAINER_BOX_UNTERFLUR,
                },
            ],
        },
        {
            type: TechSector.WATER,
            img: imgWaterFull,
            secondParts: [
                {
                    direction: 'Up',
                    config: {
                        coordinates: { x: 680, y: 180 },
                        building: BuildingType.SKYSCRAPER_WATER_UPPER,
                        link: `${BuildingType.SKYSCRAPER_WATER_UPPER}/${TechSector.WATER}`
                    }
                },
                {
                    direction: 'Down',
                    config: {
                        coordinates: { x: 580, y: 740 },
                        building: BuildingType.SKYSCRAPER_WATER_LOWER,
                        link: `${BuildingType.SKYSCRAPER_WATER_LOWER}/${TechSector.WATER}`
                    }
                },
            ],
        },
    ],
    img: imgOutside,
};

export const skyscraperWaterUpperConfig: SubBuilding = {
    parentBuilding: BuildingType.SKYSCRAPER,
    img: imgWaterUpper,
    techSectors: [
        {
            type: TechSector.WATER,
            secondParts: [{
                direction: 'Down',
                config: {
                        coordinates: { x: 820, y: 850 },
                    building: BuildingType.SKYSCRAPER_WATER_LOWER,
                    link: `${BuildingType.SKYSCRAPER_WATER_LOWER}/${TechSector.WATER}`
                }
            }],
        },
    ],
    products: [
        {
                position: { x: 1149, y: 701 },
            type: ProductType.DELTA_MACRO,
        },
        {
                position: { x: 1234, y: 789 },
            type: ProductType.SISTO_16_TWA,
        },
        {
                position: { x: 1309, y: 746 },
            type: ProductType.BOA_COMPACT_EKB,
        },
    ],
};

export const skyscraperWaterLowerConfig: SubBuilding = {
    parentBuilding: BuildingType.SKYSCRAPER,
    img: imgWaterLower,
    techSectors: [
        {
            type: TechSector.WATER,
            secondParts: [{
                direction: 'Up',
                config: {
                    coordinates: { x: 820, y: 130 },
                    building: BuildingType.SKYSCRAPER_WATER_UPPER,
                    link: `${BuildingType.SKYSCRAPER_WATER_UPPER}/${TechSector.WATER}`
                }
            }],
        },
    ],
    products: [
        {
            position: { x: 962, y: 843 },
            type: ProductType.DELTA_MACRO,
        },
        {
            position: { x: 1037, y: 800 },
            type: ProductType.BOA_COMPACT_EKB,
        },
        {
            position: { x: 1382, y: 871 },
            type: ProductType.SISTO_16_TWA,
        },
    ],
};

export default skyscraperConfig;
